module.exports = __webpack_public_path__ + "348fed00246739d63d04e24e94769694.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/error-new.svg
// module id = 497
// module chunks = 65